export enum Genders {
  MALE = 'male',
  FEMALE = 'female',
  OTHER = 'other',
}
